import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, Check, ChevronUp, ChevronDown } from 'lucide-react';

export default function MobileInvestmentBar({ property }) {
    const initialAmount = parseInt(property.minInvestment?.replace(/[^0-9]/g, '')) || 1000;
    const [amount, setAmount] = useState(initialAmount);
    const [isAdded, setIsAdded] = useState(false);

    const tokenPrice = parseInt(property.tokenPriceAED?.replace(/[^0-9]/g, '')) || 165;
    const tokens = (amount / tokenPrice).toFixed(2);

    const handleSubscribe = () => {
        setIsAdded(true);
        setTimeout(() => setIsAdded(false), 2000);
    };

    return (
        <div className="lg:hidden fixed bottom-0 left-0 right-0 z-[60] px-6 pb-8 pt-4">
            {/* Background Blur Overlay (Light) */}
            <div className="absolute inset-0 bg-white/90 backdrop-blur-2xl border-t border-gray-100 shadow-[0_-10px_40px_rgba(0,0,0,0.05)]" />

            <div className="relative flex flex-col gap-4 w-full max-w-md mx-auto">
                {/* 1. New Investment Console (The Black Bar) */}
                <div className="bg-[#0f0f11] rounded-2xl p-4 flex items-center justify-between border border-white/5 shadow-2xl">
                    <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                            <span className="text-[10px] font-black text-emerald-500 uppercase tracking-widest">Amount</span>
                            <div className="w-4 h-px bg-white/20" />
                            <span className="text-[10px] font-bold text-gray-500">≈ {tokens} Tokens</span>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="flex items-baseline gap-2">
                                <span className="text-xs font-bold text-gray-400">AED</span>
                                <span className="text-2xl font-bold text-white tracking-tighter">{amount.toLocaleString()}</span>
                            </div>
                            <div className="flex flex-col -gap-1">
                                <button onClick={() => setAmount(prev => prev + 100)} className="text-gray-600 hover:text-white transition-colors p-0.5">
                                    <ChevronUp size={16} strokeWidth={3} />
                                </button>
                                <button onClick={() => setAmount(prev => Math.max(0, prev - 100))} className="text-gray-600 hover:text-white transition-colors p-0.5">
                                    <ChevronDown size={16} strokeWidth={3} />
                                </button>
                            </div>
                        </div>
                    </div>

                    <button
                        onClick={handleSubscribe}
                        disabled={isAdded}
                        className={`h-14 px-8 rounded-xl font-black text-sm uppercase tracking-widest transition-all active:scale-95 shadow-lg ${isAdded ? 'bg-emerald-500 text-white' : 'bg-white text-black hover:bg-gray-100'
                            }`}
                    >
                        {isAdded ? 'Subscribed' : 'Subscribe'}
                    </button>
                </div>
            </div>
        </div>
    );
}
